module.exports = __webpack_public_path__ + "media/images/avatar/03-1849aeb0a8cc0355fa68da62efe8da0e.jpg";